import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'

const initialState = {
  currentUser: null,
  loading: true,
  error: null,
  generalError: null
}


export const loginAsync = createAsyncThunk('auth/login', async ({ user }, { rejectWithValue }) => {
  try {
    const response = await axios.post(`/api/v1/auth/signin`, user).then((resp) => resp.data)
    return { currentUser: response.currentUser }
  } catch (error) {
    console.error(error)
    return rejectWithValue(error.response.data)
  }
})

export const logoutAsync = createAsyncThunk('auth/logout', async () => {
  await axios.post(`/api/v1/auth/signout`)
  return { success: true }
})

export const checkAuthStatusAsync = createAsyncThunk('auth/checkAuthStatus', async () => {
  const { currentUser } = await axios.get(`/api/v1/auth/me`).then((resp) => resp.data)
  return { currentUser }
})

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    clearErrors: (state) => {
      state.error = null
    },
    setGeneralError: (state, action) => {
      state.generalError = action.payload.error
    },
    clearGeneralError: (state) => {
      state.generalError = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginAsync.pending, (state) => {
        state.loading = true
        state.error = null
        state.generalError = null
      })
      .addCase(loginAsync.fulfilled, (state, action) => {
        state.loading = false
        state.currentUser = action.payload.currentUser
      })
      .addCase(loginAsync.rejected, (state, action) => {
        state.loading = false
        state.generalError = action.payload.error
      })
      .addCase(logoutAsync.fulfilled, (state, action) => {
        state.loading = false
        state.currentUser = null
      })
      .addCase(logoutAsync.rejected, (state, action) => {
        state.loading = false
        state.error = 'Internal server error logging out'
      })
      .addCase(checkAuthStatusAsync.pending, (state) => {
        state.loading = true
      })
      .addCase(checkAuthStatusAsync.fulfilled, (state, action) => {
        state.loading = false
        state.currentUser = action.payload.currentUser
      })
      .addCase(checkAuthStatusAsync.rejected, (state, action) => {
        state.loading = false
        state.currentUser = null
      })
  }
})

export const { clearErrors, clearGeneralError, switchRole, setGeneralError } =
  authSlice.actions

export default authSlice.reducer
